import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';
import { Subscription } from 'rxjs';
import { HardwareScanProgress } from 'src/app/modules/hardware-scan/enums/hardware-scan.enum';
import { DeviceService } from 'src/app/services/device/device.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { HardwareScanService } from '../services/hardware-scan.service';
import { PreviousResultService } from '../services/previous-result.service';
import { ScanExecutionService } from '../services/scan-execution.service';
import { SnapshotService } from '../../snapshot/services/snapshot.service';

@Component({
	selector: 'vtr-page-hardware-scan',
	templateUrl: './page-hardware-scan.component.html',
	styleUrls: ['./page-hardware-scan.component.scss'],
})
export class PageHardwareScanComponent implements OnInit, OnDestroy {
	backarrow = '< ';
	cardContentPositionA: any;
	notificationSubscription: Subscription;
	routeSubscription: Subscription;
	currentRouter: any;
	hidePreviousResult = false;
	isSnapshotEnabledOnHypothesis = false;
	showDownloadToolCard = true;

	constructor(
		public deviceService: DeviceService,
		private commonService: CommonService,
		private hardwareScanService: HardwareScanService,
		private translate: TranslateService,
		private router: Router,
		private previousResultService: PreviousResultService,
		private snapshotService: SnapshotService,
		private scanExecutionService: ScanExecutionService
	) {}

	async ngOnInit() {
		this.routeSubscription = this.router.events.subscribe(() => this.observerURL());
		// This router validation is used in case of back button clicked to view-results page.
		// It's being hidden the widget if is in the view results page or does not has previous results.
		this.hidePreviousResult = this.router.url.split('/').pop() === 'view-results';

		this.isSnapshotEnabledOnHypothesis = await this.snapshotService.isAvailable();
	}

	ngOnDestroy() {
		if (this.notificationSubscription) {
			this.notificationSubscription.unsubscribe();
		}
		if (this.routeSubscription) {
			this.routeSubscription.unsubscribe();
		}
	}

	private observerURL() {
		const currentPath = this.router.url;
		const page = currentPath.split('/').pop();
		switch (page) {
			case 'view-results':
				this.hidePreviousResult = true;
				break;
			default:
				this.hidePreviousResult = false;
				break;
		}
	}

	public isLoadingDone() {
		if (this.hardwareScanService) {
			return this.hardwareScanService.isLoadingDone();
		}
	}

	public isScanDoneExecuting() {
		if (this.hardwareScanService) {
			return this.hardwareScanService.isScanDoneExecuting();
		}
	}

	public isScanExecuting() {
		if (this.hardwareScanService) {
			return this.hardwareScanService.isScanExecuting();
		}
	}

	public isRecoverExecuting() {
		if (this.hardwareScanService) {
			return this.hardwareScanService.isRecoverExecuting();
		}
	}

	public getProgress() {
		if (this.hardwareScanService) {
			return this.hardwareScanService.getProgress();
		}
	}

	public setTitle() {
		if (this.hardwareScanService) {
			if (this.isRecoverExecuting()) {
				return this.translate.instant('hardwareScan.recoverBadSectors.title');
			} else {
				return this.translate.instant('hardwareScan.name');
			}
		}
	}

	public hasDevicesToRecoverBadSectors() {
		if (this.hardwareScanService) {
			if (!this.hardwareScanService.isRecoverExecuting()) {
				return this.hardwareScanService.getHasItemsToRecoverBadSectors();
			}
			return false;
		}
	}

	public isRecoverDisabled() {
		const isExecuting =
			!this.hardwareScanService.isScanDoneExecuting() &&
			(this.hardwareScanService.isScanExecuting() ||
				this.hardwareScanService.isRecoverExecuting());
		return isExecuting || this.scanExecutionService.scanClicked;
	}

	public redirectBack() {
		// Clearing the last response received from Scan/RBS to ensure that
		// the Hardware Components page will be shown, since user just clicked
		// in the back button.
		this.hardwareScanService.clearLastResponse();
		this.commonService.sendNotification(HardwareScanProgress.BackEvent);
	}

	public hasPreviousResults(): boolean {
		if (this.previousResultService) {
			return this.previousResultService.hasPreviousResults();
		} else {
			return false;
		}
	}

	public shouldShowPreviousResultsWidget(): boolean {
		return (
			!this.isScanExecuting() &&
			!this.isRecoverExecuting() &&
			!this.hidePreviousResult &&
			this.hasPreviousResults()
		);
	}
}
